import React from 'react'
import JobsListing from '../Components/Jobs/JobsListing'

function Career() {
    return (
        <>
            <div className="job-listing-page pd-top-170">
                <div className="container">
                    <div className="job-position-area">
                        <div className="row justify-content-center">
                            <div className="col-xl-8">
                                <div className="section-title style-four pb-4">
                                    <h2 className="title">Open <span>Job</span> Positions</h2>
                                </div>
                                <JobsListing />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Career